module.exports = __webpack_public_path__ + "static/media/PNG.0b4d87fd.png";